import React from "react";
import PropTypes from "prop-types";

class DropDownList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowOption: false,
    };

    this.wrapperRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isShowOption } = this.state;
    if (prevState.isShowOption !== isShowOption) {
      if (isShowOption) {
        document.addEventListener("click", this.handleClickOutside);
      } else {
        document.removeEventListener("click", this.handleClickOutside);
      }
    }
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef?.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      this.setState({ isShowOption: false });
    }
  };

  show = () => {
    this.setState({ isShowOption: true });
  };

  hide = () => {
    this.setState({ isShowOption: false });
  };

  select = (item, index) => {
    const { onChange } = this.props;
    this.setState({
      isShowOption: false,
    });
    onChange && onChange(item, index);
  };

  render() {
    const { list, className } = this.props;
    const { isShowOption } = this.state;
    return (
      <React.Fragment>
        {isShowOption && list && list.length > 0 ? (
          <div
            ref={this.wrapperRef}
            className={`menu-drop-down-list-container ${className || ""}`}
          >
            {list.map((item, index) => {
              return (
                <div
                  onClick={() => this.select(item, index)}
                  className="menu-drop-down-list-item"
                  key={index}
                  tabIndex="0"
                >
                  {item.text}
                </div>
              );
            })}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

DropDownList.propTypes = {
  className: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func,
};

DropDownList.defaultProps = {
  className: "",
  onChange: undefined,
};

export default DropDownList;
